import { render, staticRenderFns } from "./edit-input.vue?vue&type=template&id=18861d06&scoped=true"
import script from "./edit-input.vue?vue&type=script&lang=js"
export * from "./edit-input.vue?vue&type=script&lang=js"
import style0 from "./edit-input.vue?vue&type=style&index=0&id=18861d06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18861d06",
  null
  
)

export default component.exports